import cx from "classnames";
import React, { CSSProperties } from "react";
import { formatPercent } from "shared/lib";
import styles from "./percent.module.scss";

export interface IPercent {
  children?: string | number | undefined | never[] | false;
  colorized?: boolean;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const Percent = (props: IPercent) => {
  const percent = Number(props.children);

  const red = percent < 1;
  const green = false; // percent >= 1.1;

  return (
    <span
      className={cx(
        styles.percent,
        props.colorized && red && styles.red,
        props.colorized && green && styles.green,
        props.className
      )}
      style={props.style}
      id={props.htmlId}
    >
      {props.children !== false && props.children !== undefined && formatPercent(percent)}
    </span>
  );
};

Percent.defaultProps = {};
